export const TransactionValuesVer2301 = {
    // Welcome Back:
    AnnouncementShowMe: 'AnnouncementShowMe',
    AnnouncementNoThanks: 'AnnouncementNoThanks',
    AnnouncementClose1: 'AnnouncementX1',

    // TO DO list:
    AnnouncementNext2: 'AnnouncementNext2',
    AnnouncementClose2: 'AnnouncementX2',

    // Automation:
    AnnouncementNext3: 'AnnouncementNext3',
    AnnouncementClose3: 'AnnouncementX3',

    // Tax:
    AnnouncementNext4: 'AnnouncementNext3',
    AnnouncementClose4: 'AnnouncementX4',

    // New Design Mobile:
    AnnouncementNext5: 'AnnouncementNext4',
    AnnouncementClose5: 'AnnouncementX5',

    // Mobile workSpace:
    AnnouncementNext6: 'AnnouncementNext5',
    AnnouncementClose6: 'AnnouncementX6',

    // Mobile inline:
    AnnouncementOkGotIt: 'AnnouncementOkGotIt',
    AnnouncementClose7: 'AnnouncementX7'
};
